import AppAdapter from 'adapters/app';

class RefundAdapter extends AppAdapter {
  constructor(props) {
    super(props)
  }

	static userId = '';
	static providerId = '';

}

export default RefundAdapter;